import { render, staticRenderFns } from "./BTTaskList.vue?vue&type=template&id=44636223"
import script from "./BTTaskList.vue?vue&type=script&lang=js"
export * from "./BTTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports